#import "../fragments/account-hierarchy-fragment.graphql"

mutation RemoveAccountParent($input: AccountParentRemoveInput!) {
    accountParentRemove(input: $input) {
        account {
            ...AccountHierarchyFragment
        }
        parentAccount {
            ...AccountHierarchyFragment
        }
    }
}
